module.exports = __webpack_public_path__ + "img/Ekko-header-v4@2x.2f585c95.png";